module.exports = __webpack_public_path__ + "static/img/40011 (3).06e37be.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40011 (3).webp
// module id = uzzf
// module chunks = 14